import React from 'react';

const FreeNotes = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold mb-2">Free Notes</h2>
    <p className="text-gray-600">This is the Free Notes page.</p>
  </div>
);

export default FreeNotes;
